module.exports = __webpack_public_path__ + "static/media/Colette Straight Single Headboard - 90 cm_Brown.411ef2bc.png";